import React from 'react'
import _ from 'lodash'

export default ({ label, description, baseName, ...rest }) => (
  <label style={styles.container} {..._.omit(rest, 'enabled', 'filled')}>
    <div style={styles.label}>
      {label} =
    </div>
    <div style={styles.description}>
      {description}
    </div>
  </label>
)

const styles = {
  container: {
    width: '100%',
    padding: '2px 5px 0 0',
    cursor: 'pointer',
  },
  label: {
    fontSize: '16px',
  },
  description: {
    paddingTop: '5px',
    fontSize: '13px',
  },
}
